module.exports = __webpack_public_path__ + "static/media/payment_character.3c3a3204.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment_character.png
// module id = 1109
// module chunks = 21